var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Label',{attrs:{"text":_vm.descricao,"theme":_vm.config.theme,"icon":_vm.config.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }